/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable prettier/prettier */
import { Box, Button, Card, Container, Grid, Typography, useTheme } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import { Navigate, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import {  useSearchParams } from "react-router-dom";
import UpdateProject from "../components/UpdateProject";
import VerifyOwnership from "../components/Verify/verifywebsite";
import BackButton from "../components/BackButton/BackButton";
import SiteAudit from "../components/SiteAudit/SiteAudit";
import { GetUserWebsiteData } from "../hooks/userWebsiteData";
import UptimeMonitoringSetting from "../components/uptime-monitoring/UptimeMonitoringSetting";
import useQuery from "../hooks/allQuery";
import { SCRAPY_DATA } from "../gql/queries/userWebSiteList";
import { getDomain } from "../utils/myUtills";
import Popup from "./Popup";
import { DELETE_PROJECT_BY_ID } from "../gql/mutations/userWebSiteVisit";
import CreateProjectLink from "../components/createProject/CreateProjectLink";

const TabWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  bgcolor: "background.paper",
  display: "flex",
  minHeight: 224,

  "& button:focus": {
    outline: "0",
  },
  "& button.Mui-selected": {
    color: theme.palette.common.white,
  },

  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.common.orange,
  },
  "& .BtnWrapper": {
    "& button": {
      background: theme.palette.primary.main,
    },
  },
  " .MuiSwitch-thumb": {
    color: `${theme.palette.text.primary} !important`,
  },
  "& .Mui-checked .MuiSwitch-thumb": {
    color: `${theme.palette.primary.main} !important`,
  },
}));

const TabBtnWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "15px",
  "@media screen and (max-width:768px)": {
    gap: "18px",
    flexDirection: "column",
    paddingTop: "15px",
  },
  "@media screen and (max-width:600px)": {
    alignItems: "flex-start",
  },
  "& .TabLabelWrapper": {
    "@media screen and (max-width:600px)": {
      width: "100%",
    },
    "& .InnerTabWrapper": {
      minHeight: "auto",
      "& .MuiTabs-flexContainer": {
        overflow: "auto",
        "@media screen and (max-width:600px)": {
          paddingBottom: "12px",
        },
        "& button": {
          textTransform: "none",
          minHeight: "auto",
          border: theme.palette.mode === "dark" ? "1px solid #333F55" : "1px solid #e5eaef",
          borderRight: "none",
          "&:first-of-type": {
            borderTopLeftRadius: "50px",
            borderBottomLeftRadius: "50px",
          },
          "&:last-of-type": {
            borderRight: theme.palette.mode === "dark" ? "1px solid #333F55" : "1px solid #e5eaef",
            borderTopRightRadius: "50px",
            borderBottomRightRadius: "50px",
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: "#ffffff",
          },
          "&:focus": { outline: "none" },
        },
      },
      "& .MuiTabs-indicator": { display: "none" },
    },
  },
}));
const CreateProjectButton = {
  textTransform: "none",
  backgroundColor: "#ff642d",
  color: "#fff",
  borderRadius: "5px",
  boxShadow: "none",
  mb: "15px",
  mr: "15px",
  "& a": {
    color: "#ffffff",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Plus Jakarta Sans', sans-serif !important",
    "& svg": { mr: "6px", fontSize: "22px", transition: "0.9s ease-out" },
  },
  "&:hover": { backgroundColor: "transparent", boxShadow: "none", "& a": { color: "#ff642d" }, "& svg": { transform: "rotateZ(720deg)" } },
  "&:focus": { outline: "none" },
};

const BoxWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "7px",
  "& h3": {
    fontSize: "24px",
    fontWeight: 100,
    marginBottom: "20px",
  },
  "& .ProjectWrapper1": {
    display: "flex",
    flexDirection: "column",
    // marginBottom: "20px",
    "& h2": { fontSize: "18px", fontWeight: 600, marginBottom: "4px" },
    "& a": {
      color: theme.palette.primary.main,
      "& svg": {
        fontSize: "14px",
        marginLeft: "5px",
        marginTop: "0px",
      },
    },
  },
}));
const TabDataWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& > button": {
    textTransform: "none",
    background: "#ff642d",
    color: "#fff",
    borderRadius: "2px",
    p: "5px 16px",
    border: "1px solid #ff642d",
    "&:hover": {
      background: "transparent",
      color: "#ff642d",
    },
  },
};
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  display: "flex",
  alignItems: "start",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "70px",
  "& .BtnTopWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
  },
}));

const ImportantWrapper = styled(Box)(({ theme }) => ({
  "& h4": {
    color: theme.palette.text.primary,
    fontSize: "25px",
    fontWeight: 600,
  },
  "& .BtnWrapper": {
    marginTop: "25px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box sx={{ flexGrow: "1" }} role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}
function WebSettingTab({ ProjectData }) {
  const { ownerId } = useParams();
  const [searchParams] = useSearchParams();
  const [deleteClicked, setDeleteClicked] = useState();
  const [value, setValue] = useState(0);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { allQuery } = useQuery();
  const { userData } = useSelector(state => state.reducer);
  const [DeleteProjectById] = useMutation(DELETE_PROJECT_BY_ID);
  const customizer = useSelector(state => state.customizer);
  const theme = useTheme();
  const borderColor = theme.palette.divider;
  const [open, setOpen] = useState(false);
  const [propsdata, setPropsData] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleDeleteSubmit = async ({ id }) => {
    setLoader(true);
    allQuery({
      QUERY: DeleteProjectById,
      variables: {
        payload: {
          projectId: id,
        },
      },
      type: "delete",
      cacheQueryData: {
        cacheQuery: SCRAPY_DATA,
        variablesCache: {
          params: userData.id,
        },
      },
      onCompleteFunc: async data => {
        setOpen(false);
        if (data.deleteUserProject) {
          setLoader(false);
          navigate("/dashboard?menu=dashboard");
        }
      },
    });
    setLoader(false);
    setOpen(false);
  };

  const handleDelete = id => {
    setDeleteClicked(id);
  };

  useEffect(() => {
    if (ProjectData) {
      setPropsData(ProjectData);
    }
    // eslint-disable-next-line
  }, [ProjectData]);
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0} sx={{ justifyContent: "center" }}>
            <Grid item xs={12} md={12}>
              <Box sx={{ width: "100%" }}>
                <Card
                  sx={{
                    padding: "16px 16px 16px 16px",
                    border: `1px solid ${theme.palette.divider}`,
                    boxShadow: "none !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15px",
                    "@media screen and (max-width:600px)": {
                      flexDirection: "column",
                      alignItems: "stretch",
                    },
                  }}
                >
                  <Box className="BtnTopWrapper">
                    <BackButton sx={{ "& button": { marginBottom: "0 !important" } }} />
                    <CreateProjectLink />
                  </Box>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <BoxWrapper>
                <Card
                  sx={{ padding: { xs: "16px 16px 16px 16px", sm: "30px 45px 24px 40px" }, border: customizer.isCardShadow ? `1px solid ${borderColor}` : "none" }}
                  elevation={customizer.isCardShadow ? 9 : 0}
                  variant={!customizer.isCardShadow ? "outlined" : undefined}
                >
                  <TabBtnWrapper>
                    <Box className="ProjectWrapper1">
                      <Typography component="h2">{searchParams.get("origin")}</Typography>
                      <Typography component="a" target="_blank" rel="noopener noreferrer" href={propsdata && propsdata.website}>
                        {propsdata && getDomain(propsdata.website)}
                        <LaunchIcon fontSize="16px" />
                      </Typography>
                    </Box>
                    <Box className="TabLabelWrapper">
                      <Tabs value={value} aria-label="basic tabs example" onChange={handleChange} className="InnerTabWrapper">
                        <Tab label="Scope" />
                        <Tab label="Verify" />
                        <Tab label="Site audit" />
                        <Tab
                          label="Delete"
                          onClick={() => {
                            handleDelete(ownerId);
                          }}
                        />
                        <Tab label="Uptime Monitoring" />
                      </Tabs>
                    </Box>
                  </TabBtnWrapper>

                  <Box sx={TabDataWrapper}>
                    <TabWrapper sx={{}}>
                      <TabPanel value={value} index={0}>
                        <UpdateProject propsdata={propsdata} setPropsData={setPropsData} />
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <VerifyOwnership varifyBoolean />
                      </TabPanel>
                      <TabPanel value={value} index={2}>
                        <SiteAudit />
                      </TabPanel>
                      <TabPanel value={value} index={3}>
                        {deleteClicked && (
                          <ImportantWrapper>
                            <Typography component="h4">Important</Typography>
                            <Typography sx={{ mt: "10px" }} component="p">
                              Are you sure you want to delete?
                            </Typography>
                            <Box className="BtnWrapper">
                              <Button
                                variant="contained"
                                sx={CreateProjectButton}
                                onClick={() => {
                                  setOpen(true);
                                }}
                              >
                                Delete
                              </Button>
                              {/* <Button variant="contained" sx={CreateProjectButton} onClick={handleDeleteClose}>
                                Cancel
                              </Button> */}
                            </Box>
                          </ImportantWrapper>
                        )}
                      </TabPanel>
                      <TabPanel value={value} index={4}>
                        <UptimeMonitoringSetting projectid={ownerId} />
                      </TabPanel>
                    </TabWrapper>
                  </Box>
                </Card>
                {open && <Popup ownerId={ownerId} handleDeleteSubmit={handleDeleteSubmit} propsdata={propsdata} open={open} setOpen={setOpen} loader={loader} />}
              </BoxWrapper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}
function WebsiteSetting() {
  const { ownerId } = useParams();
  const { ProjectData } = GetUserWebsiteData(ownerId);
  if (ProjectData === null) {
    return <Navigate to={"/"} />;
  }
  if (ProjectData) return <WebSettingTab ProjectData={ProjectData} />;
}
export default WebsiteSetting;
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
